import { UserPreferencesConfig } from 'softcat:config/user-preferences.ts';
import { SoftcatApiLocation } from 'softcat:types/softcat-api.ts';
import { SearchParameterUtils } from 'softcat:utils/search-parameters.ts';
import { SoftcatApiUtils } from 'softcat:utils/softcat-api.ts';

const create = async (data: Partial<SoftcatApiLocation>): Promise<SoftcatApiLocation> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    return SoftcatApiUtils.post<SoftcatApiLocation>(`/locations?${parameters}`, { body: { ...data, territory } });
};

const findAll = async ({ limit = 10, page = 0, query = '', orderBy = '' }: { limit?: number; orderBy?: string; page?: number; query?: string } = {}): Promise<
    SoftcatApiLocation[]
> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(
        SearchParameterUtils.removeEmptySearchParameters({
            filter: `territory=${territory}${query ? `,name==*${query}*` : ''}`,
            limit: `${limit}`,
            offset: `${page}`,
            orderBy: `${orderBy}`,
            territory: `${territory}`,
        }),
    );

    return SoftcatApiUtils.get<SoftcatApiLocation[]>(`/locations?${parameters}`);
};

const findOne = async ({ name }: { name: string }): Promise<SoftcatApiLocation> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    return SoftcatApiUtils.get<SoftcatApiLocation>(`/locations/${name}?${parameters}`);
};

const remove = async ({ name }: { name: string }): Promise<void> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    return SoftcatApiUtils.remove(`/locations/${name}?${parameters}`);
};

const update = async (data: Partial<SoftcatApiLocation>): Promise<SoftcatApiLocation> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    return SoftcatApiUtils.put<SoftcatApiLocation>(`/locations/${data.name}?${parameters}`, { body: data });
};

export const LocationService = {
    create,
    findAll,
    findOne,
    remove,
    update,
};
